import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AuthService } from './auth.service';

const initializeSession = async () => {
  await firstValueFrom(inject(AuthService).bootstrapSession());
};

export const provideSessionBootstrap = (): EnvironmentProviders => provideAppInitializer(initializeSession);
